import { createFileRoute } from '@tanstack/react-router';

import { PartCreateWizard } from '../../../modules/parts/part-create-wizard.js';

export const Route = createFileRoute('/parts/new/')({
  component: () => <PartCreateWizard />,
});
